import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

export const BackButton = ({path}) => {
    const navigate = useNavigate();
    return <Button variant="contained" className="px-4 py-2 uppercase" onClick={() => navigate(path)}> Back</Button>
}